module.exports = __webpack_public_path__ + "static/media/parentUser.1027914f.svg";